import { ExceptionRuleBaseType } from "@fairfleet/geotab";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

export function useRulesByName(names?: string[], baseType?: ExceptionRuleBaseType) {
  const { geotabClient, activeSessionId } = useGeotabClient();
  return useQuery({
    queryKey: ["rule", activeSessionId, names],

    queryFn: ({ signal }) => {
      if (!names) return Promise.resolve([]);
      return Promise.all(
        names.map(name => geotabClient.get("Rule", { name, baseType }, 50000, signal)),
      );
    },

    enabled: !!names,
    placeholderData: keepPreviousData,
  });
}
